export default __webpack_public_path__ + "static/media/flag.ba7c4bf7.svg";